import { Choices } from "../interface"

export const yesNoChoice: Choices[] = [
    {
        id: "true",
        ref: "true",
        title: "Да",
        comment: null,
        image: null,
    },
    {
        id: "false",
        ref: "false",
        title: "Нет",
        comment: null,
        image: null,
    },
]
